"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _inputRadio = require("@citrus/input-radio");
var _tag = require("@citrus/tag");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var _Tag;
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    builderType = _ref.builderType,
    scenario = _ref.scenario,
    question = _ref.question,
    options = _ref.options,
    otherQuestion = _ref.otherQuestion,
    selectedIndex = _ref.selectedIndex,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    hint = _ref.hint,
    number = _ref.number,
    displayFormat = _ref.displayFormat,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.multipleChoice;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    typeId: questionTypeId,
    otherQuestion: otherQuestion
  };
  var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, builderType);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), editable ? /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }) : /*#__PURE__*/_react.default.createElement(_inputRadio.Radio, {
    columns: displayFormat || 1,
    id: id,
    labelAddOn: function labelAddOn() {
      return (0, _PctyQuestionBuilder.renderKnockout)(id, knockout, knockoutText);
    },
    onChange: function onChange() {}
  }, getListItems({
    id: id,
    otherQuestion: otherQuestion,
    options: options,
    selectedIndex: selectedIndex
  })));
};
var getListItems = function getListItems(_ref2) {
  var id = _ref2.id,
    otherQuestion = _ref2.otherQuestion,
    options = _ref2.options,
    selectedIndex = _ref2.selectedIndex;
  var retOptions = options.map(function (x, index) {
    return /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
      key: "".concat(id, "-options-").concat(x.id),
      value: x.id
    }, x.value, " ", index === selectedIndex ? _Tag || (_Tag = /*#__PURE__*/_react.default.createElement(_tag.Tag, {
      type: "positive",
      value: "Correct"
    })) : '');
  });
  if (otherQuestion && otherQuestion.enabled) {
    retOptions.push( /*#__PURE__*/_react.default.createElement(_inputRadio.Radio.Item, {
      key: "".concat(id, "-options-otherOption"),
      value: id
    }, otherQuestion.label));
  }
  return retOptions;
};
var _default = exports.default = Presentational;